<div class="filter-wrapper">
  <div class="w-100 mb-6 pb-3 flex align-center justify-space-between brd-b brd-200">
    <h3 class="h4 m-0 weight-normal">{{ "Filter.Filters" | translate }}</h3>
    <button type="button" class="header__close radius-2 text-800 cursor p-0" aria-label="Close" (click)="emitEventToFilterForm(filterAction.Cancel)">
      <app-icon name="outline-cross" size="xxs"></app-icon>
    </button>
  </div>

  <!-- The only scrolling area; the header and footer stay put. -->
  <div class="filter-wrapper__body scrollable scrollable--y">
    <ng-container [ngSwitch]="tabGroup">
      <ng-container *ngSwitchCase="groups.Dashboard">
        <app-organization-business-status [action]="filterAction$"></app-organization-business-status>
      </ng-container>

      <ng-container *ngSwitchCase="groups.Shipments">
        <app-shipments-filter *ngIf="isOpened" [action]="filterAction$"></app-shipments-filter>
      </ng-container>

      <ng-container *ngSwitchCase="groups.Invoices">
        <app-invoices-filter [action]="filterAction$"></app-invoices-filter>
      </ng-container>

      <ng-container *ngSwitchCase="groups.DeliveryNotes">
        <app-delivery-notes-filter [action]="filterAction$"></app-delivery-notes-filter>
      </ng-container>

      <ng-container *ngSwitchCase="groups.TrucksReport">
        <app-trucks-report-filter [tabGroup]="tabGroup" [action]="filterAction$"></app-trucks-report-filter>
      </ng-container>

      <ng-container *ngSwitchCase="groups.Provider">
        <ng-container [ngSwitch]="tabIndex">
          <ng-container *ngSwitchCase="indices.Drivers">
            <app-drivers-filter [tabIndex]="tabIndex" [tabGroup]="tabGroup" [action]="filterActionSubject.asObservable()"></app-drivers-filter>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="groups.TransportationPayments">
        <app-transportation-payments-shipments-filter [tabGroup]="tabGroup" [action]="filterAction$"></app-transportation-payments-shipments-filter>
      </ng-container>

      <ng-container *ngSwitchCase="groups.PaymentDetails">
        <app-transportation-payments-shipments-filter [tabGroup]="tabGroup" [action]="filterAction$"></app-transportation-payments-shipments-filter>
      </ng-container>

    </ng-container>
  </div>

  <div class="footer-actions flex align-center justify-space-between pt-3 brd-t brd-200">
    <button type="button" class="footer-btn text-800 py-2 px-3" (click)="emitEventToFilterForm(filterAction.Reset)">
      {{ "Filter.ResetToDefault" | translate }}
    </button>

    <div class="footer-actions__main flex align-center">
      <button type="button" class="footer-btn footer-btn--cancel text-800 brd brd-200 bg-white" (click)="emitEventToFilterForm(filterAction.Cancel)">
        {{ "Buttons.Cancel" | translate }}
      </button>

      <button type="button" class="footer-btn footer-btn--apply text-white" (click)="emitEventToFilterForm(filterAction.Submit)">
        {{ "Buttons.Apply" | translate }}
      </button>
    </div>
  </div>
</div>
